interface MetricCardProps {
    label: string;
    value: string;
    accent: string;
    trend?: string;
}

export function MetricCard({
    label,
    value,
    accent,
    trend,
}: MetricCardProps) {
    return (
        <div className="rounded-2xl border border-border bg-card p-3">
            <div className="flex items-center justify-start gap-2">
                <span
                    className="inline-block h-2.5 w-2.5 flex-shrink-0 rounded-full"
                    style={{
                        background: accent,
                    }}
                />
                <span className="text-sm text-muted-foreground">
                    {label}
                </span>
            </div>

            <div className="mt-4 text-xl font-bold">
                {value}
            </div>

            {trend && (
                <div
                    className="mt-3 inline-flex rounded-full px-2 py-1 text-xs font-semibold"
                    style={{
                        background: `${accent}15`,
                        color: accent,
                    }}
                >
                    {trend}
                </div>
            )}
        </div>
    );
}